import { createProvider } from '@nvision/services/data-provider';

import type { TransportTypeFilters } from '../../models';
import * as api from './api';
import { normalizeTransportTypeFilters, normalizeTransportTypes } from './normalize';

export const fetchTransportTypes = createProvider(
  (filters: Partial<TransportTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchTransportTypes(normalizeTransportTypeFilters(filters), { signal }),
).andThen((res) => normalizeTransportTypes(res));
